import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenUtilsService } from 'core/services';
import { designerPaths } from '../../../designer.paths';


@Component({
  selector: 'ss-oidc-logout',
  templateUrl: './oidc-logout.component.html',
  styleUrls: ['./oidc-logout.component.css'],
  host: {
    class: 'full-stretch display-block'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OidcLogoutComponent {

  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs

  @ViewChild('cardHeader', { read: ElementRef<HTMLElement> })
  private _header: ElementRef<HTMLElement>

  get header() {
    return this._header?.nativeElement
  }

  constructor(
    private readonly _router: Router,
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }

  routeToDashboard() {
    this._router.navigate([designerPaths.auth])
  }
}
